var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbSocialsMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 17C34 7.61124 26.3888 0 17 0C7.61124 0 0 7.61124 0 17C0 25.485 6.21668 32.5182 14.3435 33.7936V21.914H10.0272V17H14.3435V13.2545C14.3435 8.99393 16.8813 6.64042 20.7646 6.64042C22.6247 6.64042 24.57 6.97228 24.57 6.97228V11.156H22.426C20.314 11.156 19.6554 12.4664 19.6554 13.8109V17H24.3702L23.6167 21.914H19.6554V33.7936C27.7828 32.5182 33.999 25.4855 33.999 17H34Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6168 21.914L24.3704 17H19.6556V13.8109C19.6556 12.4664 20.3142 11.1559 22.4261 11.1559H24.5701V6.97225C24.5701 6.97225 22.6248 6.64038 20.7647 6.64038C16.8814 6.64038 14.3437 8.99389 14.3437 13.2545V17H10.0273V21.914H14.3437V33.7935C15.2092 33.9293 16.0964 34 17.0001 34C17.9039 34 18.7911 33.9293 19.6566 33.7935V21.914H23.6178H23.6168Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbSocialsMobile);
export default __webpack_public_path__ + "static/media/fb-socials-mobile.f758790e2b603c030de49f45e23f0d84.svg";
export { ForwardRef as ReactComponent };